// 对话数据
import { initTreatment, getTreatmentNext, getTreatment } from '@/api/dialogue'
import { getCode } from '@/api/user'
import { Toast } from 'vant';
import request from '@/utils/request';

export default {
  state: {
    id: null, // 治疗方案id
    treatmentList: [], // 治疗流程数据
    treatmentCode: null
  },
  getters: {
  },
  mutations: {
    // 设置治疗id
    setId(state, payload) {
      state.id = payload;
    },
    // 设置治疗方案list
    setTreatmentList(state, payload) {
      state.treatmentList = payload;
    },
    setTreatmentCode(state, payload){
      state.treatmentCode = payload
    }
  },
  actions: {
    // 初始化治疗流程
    async initTreatment({ commit }) {
      try {
        const code = await getCode()
        const resData = await initTreatment(code);
        commit('setId', resData.id);
        return resData;
      } catch (error) {
        console.error(error)
        return false;
      }
    },
    /**
     * 主任务 用户发送确认消息
     */
    async postUserConfirm ({state }, data)  {
      console.log("postUserConfirm", data)
      let code = state.treatmentCode;
      let treatmentInstanceId = state.id;
      return await request.post(`/app-api/api/treatment/${code}/${treatmentInstanceId}/chat-history`, { data });
    },

    // 获取总数据
    async getTreatment({ state, commit, rootState, dispatch }) {
      try {
        const code = await getCode()
        commit('setTreatmentCode', code);
        const resData = await getTreatment({ id: state.id }, code);
        const useData = [];
        resData.forEach(resDataItem => {
          const itemData = JSON.parse(resDataItem.message)
          console.log(itemData);
          if(itemData.step_item_type === 'LIST') {
            itemData.step_items.forEach(item => {
              useData.push({
                ...itemData,
                ...item,
                id: item.id,
                type: rootState.itemTypeList[item.item_type],
                item_type: item.item_type,
                text: item.settings.content || '',
                cardMode: 'dialogue',
                isShowTime: true,
                videoUrl: item.settings?.videoUrl || '',
                status: item.status
              });
            });
          } else {
            if(itemData.step_item.item_type === 'SYS_INFO') {
              return;
            }
            useData.push({
              ...itemData,
              settings: itemData.step_item.settings,
              status: itemData.step_item.status,
              id: itemData.step_item.id,
              type: rootState.itemTypeList[itemData.step_item.item_type],
              item_type: itemData.step_item.item_type,
              text: itemData.step_item.settings.content,
              cardMode: 'dialogue',
              videoUrl: itemData.settings?.videoUrl || '',
              isShowTime: true
            });
          }
        })
        commit('setTreatmentList', useData);
        if(useData.length === 0) {
          dispatch('getTreatmentNext')
        }
        console.log(useData);
        return useData;
      } catch (error) {
        console.error(error.data?.msg || error)
        return false;
      }
    },
    // 获取用户治疗下一项内容
    async getTreatmentNext({ state, commit, rootState }, options = {}) {
      try {
        const { silent = false } = options || {};
        const code = await getCode()
        const resData = await getTreatmentNext({ id: state.id }, code);
        console.log(resData);
        if(resData.step_item_type !== 'LIST' && resData.step_item.item_type === 'SYS_INFO') {
          if(!silent) {
            Toast(resData.step_item.settings.content);
          }
          return false;
        }
        let useList = [];
        // if(state.treatmentList.length === 0) {
        //   useList = [{
        //     type: 'StartChat',
        //     text: resData.step_item.settings.content,
        //     ...resData,
        //   }]
        // } else {
        if(resData.step_item_type === 'LIST') {
          const newItems = resData.step_items.map((currentData) => ({
            ...currentData,
            id: currentData.id,
            type: rootState.itemTypeList[currentData.item_type],
            item_type: currentData.item_type,
            text: currentData.settings.content || '',
            cardMode: 'dialogue',
            videoUrl: currentData.settings?.videoUrl || '',
            isShowTime: true,
            status: currentData.status
          }));
          commit('setTreatmentList', [...state.treatmentList, ...newItems]);
          // resData.step_items.forEach(item => {
          //   stateList.push({
          //     id: item.id,
          //     type: rootState.itemTypeList[item.item_type],
          //     item_type: item.item_type,
          //     text: item.settings.content || '',
          //     cardMode: 'dialogue',
          //     videoUrl: item.settings?.videoUrl || '',
          //     isShowTime: true,
          //     status: item.status
          //   });
          // });
          // useList = stateList;
          // commit('setTreatmentList', useList);
        } else {

          useList = [
            ...state.treatmentList,
            {
              ...resData,
              settings: resData.step_item.settings,
              status: resData.step_item.status,
              id: resData.step_item.id,
              type: rootState.itemTypeList[resData.step_item.item_type],
              item_type: resData.step_item.item_type,
              text: resData.step_item.settings.content,
              cardMode: 'dialogue',
              videoUrl: resData.settings?.videoUrl || '',
              isShowTime: true
            }
          ];
          commit('setTreatmentList', useList);
        }
        // }
        return resData
      } catch (error) {
        console.error(error?.data?.msg || error)
        return false;
      }
    },
  }
}
